import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import AgreementPage from "./pages/AgreementPage";
import Stockmantraform from "./pages/Stockmantraform";
import SubmissionSuccess from "./pages/SubmissionSuccess";
import ThankYou from "./pages/ThankYou";
import NewKyc from "./userconsent/NewKyc.jsx";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<NewKyc />} />
        {/* <Route path="/user-consent" element={<NewKyc />} /> */}
        <Route path="/success" element={<SubmissionSuccess />} />
        <Route path="/agreement" element={<AgreementPage />} />
          <Route path="/thank-you" element={<ThankYou />} />   {/* NEW */}
      </Routes>
    </Router>
  );
}

export default App;
